module.exports = __webpack_public_path__ + "static/adjustable-base-2-legs-43d480d7ea36af50f7de127ed8b7d63d.webp";